module.exports = __webpack_public_path__ + "img/1.aa7f8a5b.webp";